import { Form, Modal, Select, Tag } from 'antd';
import message from '../../../utils/messageWithScroll';
import { LanguageContext } from 'contexts/LanguageContext';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import React, { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const { Option } = Select;

function LinkChannelView({
	visible,
	cancelAction,
	numberForm,
	form: { getFieldDecorator },
	bitrix24,
	number,
}) {
	const { dictionary } = useContext(LanguageContext);
	const [channel, setChannel] = useState('');

	function onChangeChannel(value) {
		setChannel(value);
	}

	async function linkChannelOkHandle(e) {
		const { linkChannel } = bitrix24;
		const { getConnectedChannels, getListCampaigns, getListOfNumbers } = number;

		e.preventDefault();

		await linkChannel(numberForm.id, channel)
			.then(() => {
				message.success(dictionary.link_channel_success);
				getConnectedChannels();
				getListCampaigns();
				getListOfNumbers();
			})
			.catch((e) => {
				console.log('LinkChannelView::linkChannelOkHandle::error', {
					Exception: e,
				});

				if (e.msg) {
					message.error(e.msg);
				} else {
					message.error(dictionary.link_channel_error);
				}
			});
	}

	return (
		<Modal
			title={<FormattedMessage id="link_channel_title" />}
			visible={visible}
			onCancel={cancelAction}
			onOk={linkChannelOkHandle}
			cancelText={<FormattedMessage id="cancel" />}
			okButtonProps={{ loading: bitrix24.loadingLinking }}
		>
			<Form className="login-form" onSubmit={linkChannelOkHandle}>
				<Form.Item>
					{getFieldDecorator('channel', {
						rules: [
							{
								required: false,
								message: <FormattedMessage id="form_msg_channel" />,
							},
						],
					})(
						<FormattedMessage id="form_channel">
							{(msg) => (
								<Select
									showSearch
									placeholder={msg}
									optionFilterProp="children"
									onChange={onChangeChannel}
									filterOption={(input, option) =>
										option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
								>
									{bitrix24.channels.map((channel) => (
										<Option value={channel.ID} key={channel.ID} disabled={channel.ACTIVE === 'N'}>
											{channel.LINE_NAME}{' '}
											{channel.ACTIVE === 'N' && (
												<Tag color="#f50">
													<FormattedMessage id="inactive" />
												</Tag>
											)}
										</Option>
									))}
								</Select>
							)}
						</FormattedMessage>,
					)}
				</Form.Item>
			</Form>
		</Modal>
	);
}

const WrappedLinkChannel = Form.create({ name: 'link_form' })(LinkChannelView);

export default Bitrix24Consumer(NumberConsumer(WrappedLinkChannel));
